import { shouldUseMocks } from './mockApi'
import * as mock from './mockApi/vitalsApi'
import { patientGet, patientPost } from './patientApi'

const BASE = '/api/secure/me/vitals'
const CTX = { requirePatientContext: true }

export async function list(profile, metric, from, to) {
  if (shouldUseMocks()) return mock.list(profile, metric, from, to)
  const res = await patientGet(BASE, { ...CTX, params: { metric, from, to } })
  return res?.data || []
}

export async function record(profile, body) {
  if (shouldUseMocks()) return mock.record(profile, body)
  const res = await patientPost(BASE, body, CTX)
  return res?.data
}

export async function requiredToday(profile) {
  if (shouldUseMocks()) return mock.requiredToday(profile)
  const res = await patientGet(`${BASE}/required-today`, CTX)
  return res?.data || []
}
